// src/components/ServersParser/serversParserData.js
// 50 реалистичных записей серверов в точности по спецификации ServersParser.html

export const INITIAL_PARSED_SERVERS = [
  {
    id: 'srv-1',
    ip: 'play.reallyworld.ru',
    port: '25565',
    version: '1.16.5',
    players: 4850,
    maxPlayers: 6000,
    vulnLevel: 'high',
    vulnBadge: 'Критическая'
  },
  {
    id: 'srv-2',
    ip: 'mc.funtime.su',
    port: '25565',
    version: '1.16.5',
    players: 3940,
    maxPlayers: 5000,
    vulnLevel: 'medium',
    vulnBadge: 'Средняя'
  },
  {
    id: 'srv-3',
    ip: 'play.masedworld.net',
    port: '25565',
    version: '1.12.2',
    players: 2150,
    maxPlayers: 3000,
    vulnLevel: 'low',
    vulnBadge: 'Низкая'
  },
  {
    id: 'srv-4',
    ip: 'play.prostocraft.ru',
    port: '25565',
    version: '1.20.4',
    players: 1890,
    maxPlayers: 2500,
    vulnLevel: 'high',
    vulnBadge: 'Критическая'
  },
  {
    id: 'srv-5',
    ip: 'mc.hypixel.net',
    port: '25565',
    version: '1.20.2',
    players: 48200,
    maxPlayers: 65000,
    vulnLevel: 'low',
    vulnBadge: 'Низкая'
  },
  {
    id: 'srv-6',
    ip: 'play.sunmc.ru',
    port: '25565',
    version: '1.16.5',
    players: 1420,
    maxPlayers: 2000,
    vulnLevel: 'medium',
    vulnBadge: 'Средняя'
  },
  {
    id: 'srv-7',
    ip: 'mc.besteria.ru',
    port: '25565',
    version: '1.12.2',
    players: 640,
    maxPlayers: 1000,
    vulnLevel: 'high',
    vulnBadge: 'Критическая'
  },
  {
    id: 'srv-8',
    ip: 'play.vimeworld.ru',
    port: '25565',
    version: '1.8.8',
    players: 3200,
    maxPlayers: 5000,
    vulnLevel: 'low',
    vulnBadge: 'Низкая'
  },
  {
    id: 'srv-9',
    ip: 'mc.cristalix.gg',
    port: '25565',
    version: '1.12.2',
    players: 2800,
    maxPlayers: 4000,
    vulnLevel: 'low',
    vulnBadge: 'Низкая'
  },
  {
    id: 'srv-10',
    ip: 'play.cubecraft.net',
    port: '25565',
    version: '1.20.4',
    players: 4500,
    maxPlayers: 8000,
    vulnLevel: 'medium',
    vulnBadge: 'Средняя'
  },
  {
    id: 'srv-11',
    ip: 'play.gommehd.net',
    port: '25565',
    version: '1.20.1',
    players: 3100,
    maxPlayers: 6000,
    vulnLevel: 'low',
    vulnBadge: 'Низкая'
  },
  {
    id: 'srv-12',
    ip: 'mc.mineblaze.ru',
    port: '25565',
    version: '1.16.5',
    players: 1750,
    maxPlayers: 2500,
    vulnLevel: 'high',
    vulnBadge: 'Критическая'
  },
  {
    id: 'srv-13',
    ip: 'play.dexland.ru',
    port: '25565',
    version: '1.16.5',
    players: 1200,
    maxPlayers: 1800,
    vulnLevel: 'medium',
    vulnBadge: 'Средняя'
  },
  {
    id: 'srv-14',
    ip: 'mc.litecloud.me',
    port: '25565',
    version: '1.12.2',
    players: 890,
    maxPlayers: 1500,
    vulnLevel: 'high',
    vulnBadge: 'Критическая'
  },
  {
    id: 'srv-15',
    ip: 'play.prostomc.org',
    port: '25565',
    version: '1.20.2',
    players: 680,
    maxPlayers: 1000,
    vulnLevel: 'low',
    vulnBadge: 'Низкая'
  },
  {
    id: 'srv-16',
    ip: 'play.aresmine.ru',
    port: '25565',
    version: '1.16.5',
    players: 2350,
    maxPlayers: 3500,
    vulnLevel: 'medium',
    vulnBadge: 'Средняя'
  },
  {
    id: 'srv-17',
    ip: 'mc.teslacraft.org',
    port: '25565',
    version: '1.12.2',
    players: 1100,
    maxPlayers: 2000,
    vulnLevel: 'low',
    vulnBadge: 'Низкая'
  },
  {
    id: 'srv-18',
    ip: 'play.minelegacy.ru',
    port: '25565',
    version: '1.16.5',
    players: 820,
    maxPlayers: 1200,
    vulnLevel: 'high',
    vulnBadge: 'Критическая'
  },
  {
    id: 'srv-19',
    ip: 'mc.redserver.su',
    port: '25565',
    version: '1.7.10',
    players: 450,
    maxPlayers: 800,
    vulnLevel: 'medium',
    vulnBadge: 'Средняя'
  },
  {
    id: 'srv-20',
    ip: 'play.mctop.su',
    port: '25565',
    version: '1.20.4',
    players: 980,
    maxPlayers: 1500,
    vulnLevel: 'low',
    vulnBadge: 'Низкая'
  }
];

// Дополняем фиксированными детерминированными серверами до 50 штук
const versionsPool = ['1.16.5', '1.20.4', '1.12.2', '1.20.1', '1.18.2', '1.8.8'];
const vulnPool = [
  { level: 'low', badge: 'Низкая' },
  { level: 'medium', badge: 'Средняя' },
  { level: 'high', badge: 'Критическая' }
];

for (let i = 21; i <= 50; i++) {
  const vObj = vulnPool[i % vulnPool.length];
  const ver = versionsPool[i % versionsPool.length];
  const players = 120 + ((i * 97) % 2300);
  const maxP = Math.round(players * 1.4);

  INITIAL_PARSED_SERVERS.push({
    id: `srv-${i}`,
    ip: `node${i}.mc-network-${i}.ru`,
    port: '25565',
    version: ver,
    players: players,
    maxPlayers: maxP,
    vulnLevel: vObj.level,
    vulnBadge: vObj.badge
  });
}

/**
 * Нормализует входящие серверные объекты WebSocket в единую структуру для таблицы
 */
export const normalizeParsedServer = (server, index = 0) => {
  if (!server) return null;

  let ip = server.ip || '127.0.0.1';
  let port = '25565';
  if (ip.includes(':')) {
    const parts = ip.split(':');
    ip = parts[0];
    port = parts[1] || '25565';
  } else if (server.port) {
    port = String(server.port);
  }

  const players = typeof server.players === 'number'
    ? server.players
    : (typeof server.online === 'number' ? server.online : 0);

  const maxPlayers = typeof server.maxPlayers === 'number' && server.maxPlayers > 0
    ? server.maxPlayers
    : Math.max(100, Math.round(players * 1.3) || 100);

  let vulnLevel = 'low';
  let vulnBadge = 'Низкая';

  const rawLevel = (server.vulnerabilityLevel || server.vulnLevel || '').toLowerCase();
  if (rawLevel.includes('high') || rawLevel.includes('crit') || rawLevel.includes('крит')) {
    vulnLevel = 'high';
    vulnBadge = 'Критическая';
  } else if (rawLevel.includes('med') || rawLevel.includes('средн')) {
    vulnLevel = 'medium';
    vulnBadge = 'Средняя';
  } else {
    vulnLevel = 'low';
    vulnBadge = 'Низкая';
  }

  return {
    id: server.id || `ws-srv-${index}-${ip}-${port}`,
    ip,
    port,
    version: server.version || '1.16.5',
    players,
    maxPlayers,
    vulnLevel,
    vulnBadge
  };
};
